<template>
	<div id="missionAndRanking" class="sign-wrap" :toiframe='toiframe' :awardIdPointer='awardIdPointer'>
		<div id="mask"></div>
		<div class="sign-top">
			<div style="display: flex;align-items: center;margin-top: 0.1rem">
				<span class="small"></span>
				<span class="big"></span>
				<h2 class="sign-top-title">累计签到赢好礼</h2>
				<span class="big"></span>
				<span class="small"></span>
			</div>
			<div class="sign-top-buttons" v-if='checkInDailyState == 0'>
				<div class="button buttons" v-for='(item,index) in checkInLimit' :key="index" :class="index+1 <= checkInDays ? 'buttonsignfinish' : index+1 == checkInDays+1 ? 'buttonsigned' : 'buttonsigned'">{{index+1 > checkInDays ? index+1 == checkInDays+1 ? '未签' : index+1+'天' : '已签' }}</div>			</div>
			<div class="sign-top-buttons" v-else>
				<div class="button buttons" v-for='(item,index) in checkInLimit' :key="index" :class="index+1 < checkInDays ? 'buttonsignfinish' : index+1 == checkInDays ? 'buttonunsigned' : 'buttonsigned'">{{index+1 > checkInDays ? index+1+'天' : '已签'}}</div>
			</div>
			<div class="button signbutton" :class="checkInDailyState == 1 || checkInDays == checkInLimit ? 'gray' :'orange'" @click='clicksign()'>{{checkInDays == checkInLimit ? '全部签到' : checkInDailyState == 1 ? '已签到' : '签到'}}</div>
			<p class="count">已签到<span class="signedcount">{{checkInDays}}</span> / <span class="signsum">{{checkInLimit}}</span>天</p>
		</div>
		<img class="decorate" src="~assets/images/missionAndRanking/lianjie.png" alt="">
		<ul class="sign-main">
			<li class="sign-main-li" v-for='item in checkInAward' :key="item.awardId">
				<p><span class="day">{{item.awardDays}}天</span></p>
				<div style="display: flex;align-items: center">
					<h3>累计签到{{item.awardDays}}天可以获得以下奖励</h3>
					<p class='pad'>
						<span class='over' v-if="item.awardDays <= checkInDays">已完成</span>
						<span class='rate' v-if='item.awardDays > checkInDays'>进度:{{checkInDays}}/{{item.awardDays}}</span>
					</p>
				</div>
				<div class="sign-mian-li-box">
					<ol class="left">
						<li v-for='ele in item.webAwardList' :key="ele.propId">
							<img :src="ele.icon" alt="">
							<span v-if="ele.awardName == '金币'">{{ele.awardQuantity}}金币</span>
							<span v-else-if="ele.awardName == '现金'">{{ele.awardQuantity/100}}元</span>
							<span v-else>{{ele.awardName.length >= 5 ? ele.awardName.substring(0, 5)+'...' : ele.awardName}}*{{ele.awardQuantity}}</span>
						</li>
					</ol>
					<div class="right">						
						<div class="button libutton" 
						:class="item.receivedState ==0 ? 'UnReceived' : item.receivedState == 1 ? 'Receivable' : item.receivedState == 2 ? 'received':'Receivable'" 
						@click='getPrice(item.awardId,item.receivedState)'>{{item.receivedState ==0 ? '未达到' : item.receivedState == 1 ? '可领取' : "已领取"}}</div>
					</div>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
	import $ from 'jquery'
	import {mapState,mapMutations} from 'vuex'
	import config from "@/../config"
	import qs from 'qs';
	import active from '@/utils/axios/index'

	export default {
		data(){
			return {
				checkInLimit: 0,//总共的签到天数
				checkInDays: 0,//已经签到的天数
				checkInDailyState: '',//今天是否签到
				checkInAward:[],//签到奖励的列表
			}
		},
		computed:{
			...mapState([
				'uuid',
				'activityStatus',
				'activityId',
				'time',
				'guide'
			])
		},
		created() {
			this.getbuttonlist()
		},
		methods: {
			// 初始化按钮状态
			getbuttonlist(){
				active.getCheckInInfo(config.API_HOST +'/apiserv/api/checkIn/getCheckInInfo', qs.stringify({
					uuid: this.uuid,
					checkInId: this.awardIdPointer,
					activityId: this.activityId
				})).then((res) => {
					if(res.return_code == 200){
						this.checkInAward = res.data.checkInAward
						this.checkInDailyState = res.data.checkInDailyState;
						this.checkInLimit = res.data.checkInLimit
						this.checkInDays = res.data.checkInDays
						this.$nextTick(() => {
							//签到中的两个盒子连接的图片的位置
							$(".decorate").css("top",$('.sign-top').height())
						})
					}else{
						this.tipConshow(res.return_msg)
					}
				})
			},
			//点击签到
			clicksign(){
				var continu = this.lock()
				if(continu){
					this.$tea('event_missionAndRanking_clicksign_10201', { 'activityId': this.activityId, 'checkInDays':this.checkInDays,'checkInDailyState':this.checkInDailyState, guide:this.guide?this.guide:false});//数据埋点
					if(this.checkInDailyState == 1){
						this.tipConshow('今日已签到，请明日再来');
						this.$tea('event_missionAndRanking_clicksignback_10201', { 'activityId': this.activityId, 'signstate':2,'signresult':'已签到','checkInDays':this.checkInDays, guide:this.guide?this.guide:false});//数据埋点
						return
					}
					active.checkInDaily(config.API_HOST +'/apiserv/api/checkIn/checkInDaily', qs.stringify({
						uuid: this.uuid,
						checkInId: this.awardIdPointer,
						activityId: this.activityId
					})).then((res) => {
						if(res.return_code == 200){
							//重新渲染页面展示状态
							this.getbuttonlist()
							if(res.data.checkInState == 1 ){//签到成功
								this.$tea('event_missionAndRanking_clicksignback_10201', { 'activityId': this.activityId, 'signstate':1,'signresult':'签到成功','checkInDays':this.checkInDays, guide:this.guide?this.guide:false});//数据埋点
							}
						}else{
							this.tipConshow(res.return_msg);
						}
					})
				}
			},
			//点击领取奖励
			getPrice(id,receivedState){
				var continu = this.lock()
				if(continu){
					this.$tea('event_missionAndRanking_canprice_10201', { 'activityId': this.activityId, 'testid':id,'receivedState':receivedState, guide:this.guide?this.guide:false});//数据埋点
					if(receivedState == 0 ){
						this.tipConshow("未达到领取天数")
						this.$tea('event_missionAndRanking_getprice_10201', { 'activityId': this.activityId, 'testid':id,'priceState':2,'result':"未达到领取天数", guide:this.guide?this.guide:false});//数据埋点
						return
					}else if(receivedState == 2){
						this.tipConshow("已领取")
						this.$tea('event_missionAndRanking_getprice_10201', { 'activityId': this.activityId, 'testid':id,'priceState':2,'result':"已领取", guide:this.guide?this.guide:false});//数据埋点
						return
					}
					active.receiveAward(config.API_HOST + '/apiserv/api/checkIn/receiveAward', qs.stringify({
						uuid: this.uuid,
						checkInId: this.awardIdPointer,
						activityId: this.activityId,
						awardId: id
					})).then((res) => {
						if(res.return_code == 200){
							if(res.data.receivedState == 2){
								this.tipConshow2(res.data.awardList)
								this.$tea('event_missionAndRanking_getprice_10201', { 'activityId': this.activityId, 'testid':id,'priceState':1,'result':"已领取", guide:this.guide?this.guide:false});//数据埋点
							}else if(res.data.receivedState == 1){
								this.tipConshow("已领取")
							}
							this.getbuttonlist()
						}else{
							this.tipConshow(res.return_msg);
						}
					})
				}
			},
			// 判断活动状态
			lock() {
				if (this.activityStatus == 0) { //活动展示期
					this.tipConshow('【' + this.time + '】开启活动，请耐心等待');
					return false;
				} else if (this.activityStatus == 1) {
					$('.button').attr('disabled', false)
					return true;
				} else if (this.activityStatus == 2) {
					this.tipConshow("活动已结束，请等待下次活动");
					return false;
				} else {
					this.tipConshow("活动已关闭，请等待下次活动");
					return false;
				}
			}
		},
	}
</script>
<style lang="less" scoped>
button, p{
	margin: 0;
	padding: 0;
}
.sign-wrap{
	width:3.51rem;
	height: auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-bottom: 0;
	position: relative;
	margin-top: 0.2rem;
}
#mask{
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	z-index: 15;
	border-radius: 0.12rem;
	display: none;
}.sign-top{
	width:3.26rem;
	background: #fff;
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	align-items: center;
	border-radius: 0.1rem;
	padding: 0.05rem;
}
.small{
	display: block;
	width: 0.15rem;
	height: 0.15rem;
	background: #FFE0C4;
	border-radius: 50%;
}
.big{
	display: block;
	width: 0.2rem;
	height: 0.2rem;
	background-color: #FFE0C4;
	border-radius: 50%;
	margin:0 0.03rem
}
.sign-top-title{
	text-align: center;
	height: 0.35rem;
	line-height: 0.25rem;
	background: #FFF3E8;
	color: #802400;
	border-radius: 0.2rem;
	padding: 0.05rem 0.2rem;
	font-size:0.12rem;
}
.sign-top-buttons{
	width:3.05rem;
	margin-top: 0.1rem;
}
.button{
	border:0;
}
.button:active {
    transform: scale(0.9)
}
.buttons{
	display: inline-block;
	width:0.41rem;
	height: 0.41rem;
	border-radius: 50%;
	color: #802400;
	font-weight: 600;
	font-size: 0.12rem;
	margin: 0.01rem;
	border:0;
	text-align: center;
	line-height: 0.41rem;
}
.buttonsignfinish{
	background: url('~assets/images/missionAndRanking/signed.png') no-repeat center;
	background-size: contain;
}
.buttonsigned{
	background: url('~assets/images/missionAndRanking/unsign.png') no-repeat center;
	background-size: contain;
}
.buttonunsigned{
	background: url('~assets/images/missionAndRanking/daysign.png') no-repeat center;
	background-size: contain;
}
.signbutton {
	width: 3rem;
	height: 0.5rem;
	margin-top: 0.2rem;
	border-radius: 0.3rem;
	font-size: 0.17rem;
	font-family: PingFangSC-Semibold, sans-serif;
	font-weight: 600;
	color: rgba(255, 255, 255, 1);
	line-height: 0.5rem;
	text-align: center;
	display: block;
	transform: scale(0.8);
}
.gray{
	background: rgba(221, 221, 221, 1);
	box-shadow: 0 0.03rem 0 0 rgba(179, 179, 179, 1), 0 0 0 0 rgba(255, 255, 255, 0.5);
}
.orange{
	background: rgba(255, 142, 31, 1);
	box-shadow: 0 0.03rem 0 0 rgba(240, 92, 0, 1), 0 0 0 0 rgba(255, 247, 227, 0.5);
}
.count{
	color: #ccc;
	margin:0.05rem;
	font-size:0.12rem;
}
.signedcount, .signsum{
	color: #FF8E1F;
}
.decorate{
	display: block;
	width: 60%;
	height: 0.3rem;
	z-index: 10;
	position: absolute;
	left: 0.7rem;
}
.sign-main{
	width:3.26rem;
	background: #fff;
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	align-items: center;
	padding: 0.1rem 0.05rem;
	border-radius:0.08rem;
	margin-top: 0.12rem;
}
.sign-main-li{
	width: 95%;
	height: 1rem;
	background:#eee;
	margin-top: 0.1rem;
	border-radius: 0.1rem;
	padding-bottom: 0.05rem;
}
.sign-main-li>p{
	width: 100%;
	height: 0.15rem;
}
.sign-main-li .day{
	display: block;
	width:0.4rem;
	height: 0.15rem;
	line-height: 0.15rem;
	background:#FFC710;
	color: #fff;
	border-radius: 0.1rem 0 0.1rem 0;
	text-align: center;
	font-size: 0.12rem;
}
.sign-main-li h3{
	padding: 0.1rem;
	font-size: 0.13rem;
}
.pad {
	min-height: 0.14rem;
	font-size: 0.12rem;
	font-family: PingFangSC-Semibold, sans-serif;
	font-weight: 600;
	color: rgba(51, 51, 51, 1);
	line-height: 0.15rem;
	display: flex;
	justify-content: space-between;
	margin: 0.1rem 0;
}
.over {
	min-width: 0.44rem;
	height: 0.14rem;
	background: url('~assets/images/over.svg') no-repeat center;
	font-size: 0.12rem;
	font-weight: 400;
	color: rgba(44, 187, 127, 1);
	line-height: 0.14rem;
	text-align: center;
	background-size: cover;
	margin-left: 0.08rem;
}
.rate {
	display: block;
	min-width: 0.57rem;
	height: 0.14rem;
	background: url('~assets/images/rate.svg') no-repeat center;
	font-size: 0.12rem;
	font-family: PingFangSC-Semibold, sans-serif;
	font-weight: 400;
	color: rgba(255, 86, 89, 1);
	line-height: 0.14rem;
	text-align: center;
	margin-left: 0.08rem;
	background-size: cover;
}
.sign-mian-li-box{
	padding: 0 0.1rem;
	display: flex;
}
.sign-mian-li-box .left{
	width:70%;
	height: 0.4rem;
	display: flex;
	flex-wrap: wrap;
}
.sign-mian-li-box .left li{
	height: 0.17rem;
	line-height: 0.17rem;
	width:50%;
	text-align: left;
	display: flex;
	align-items: center;
}
.sign-mian-li-box .left li img{
	width: 0.17rem;
	height: 0.17rem;
	display: block;
}
.sign-mian-li-box .left li span{
	height: 0.17rem;
	line-height: 0.17rem;
	display: block;
	font-size: 0.14rem;
}
.sign-mian-li-box .right{
	width: 30%;
	height: 0.4rem;
	display: flex;
	justify-content: space-around;
	align-items: center;
}
.libutton{
	width: 100%;
	height: 0.35rem;
	font-size: 0.12rem;
	font-weight: 500;
	color: rgba(255, 255, 255, 1);
	line-height: 0.35rem;
	float: right;
	border-radius: 0.18rem;
	transform: scale(0.8);
	border:0;
	text-align: center;
}
.UnReceived {
	background: rgba(255, 142, 31, 1);
	box-shadow: 0 0.02rem 0 0 rgba(232, 89, 0, 1);
}
.Receivable {
	background: rgba(253, 79, 45, 1);
	box-shadow: 0 0.02rem 0 0 rgba(188, 15, 6, 1);
}
.received  {
	background: rgba(221, 221, 221, 1);
	box-shadow: 0 0.02rem 0 0 rgba(179, 179, 179, 1);
}
@keyframes white {
  20%{
    background: rgba(238, 238, 238, 1);
  }
  50%{
    background: rgba(238, 238, 238, 0);
  }
  75%{
    background: rgba(238, 238, 238, 1);
  }
  100%{
    background: rgba(238, 238, 238, 0)
  }
}
</style>